module.exports = __webpack_public_path__ + "img/ring_g_o_1_0.26c67646.png";